import type { NavigationItemData } from '@/components/NavBar/components/NavigationItem';
import type { MarketGroup } from '@/slices/marketsListSlice';

export default function groupMarketsBySector(markets: MarketGroup[]): NavigationItemData[] {
  return markets.map(sectorName => ({
    key: sectorName.name,
    name: sectorName.name,
    path: `/markets/sector/${sectorName.name}`,

    children: sectorName.markets.map(({ name, marketId, comingSoon, tag }): NavigationItemData => {
      return {
        key: name + marketId,
        id: marketId,
        name,
        path: `/markets/${marketId}`,
        ...(comingSoon ? { tag: 'Coming Soon' } : { tag })
      };
    })
  }));
}
